module.exports = __webpack_public_path__ + "img/8_32.6b05baac.png";